module.exports = __webpack_public_path__ + "img/spinner.2f2d9dc2.gif";